export default function sample(){

  if(document.querySelector('.site-sample')){

    document.querySelectorAll('.sample-item li').forEach(li => {
      li.addEventListener('click', function () {
        if (this.classList.contains('active')) {
          this.classList.remove('active')
        } else {
          const activeItems = document.querySelectorAll('.sample-item li.active')
          if (activeItems.length === 2) {
            alert('กรุณาเลือก 2 รายการ')
          } else {
            this.classList.add('active')
          }
        }
      })
    })
  
    document.querySelectorAll('.option-list li').forEach(li => {
      li.addEventListener('click', function () {
          document.querySelectorAll('.option-list li').forEach(child => {
            child.classList.remove('active')
          })
          this.classList.add('active')
      })
    })
  
  
    document.getElementById('submit-button').addEventListener('click', function (ev) {
      const choices = document.querySelectorAll('.choice.active')
      if (choices.length === 0) {
        window.alert('กรุณาเลือกตัวอย่าง')
        return
      } else if (choices.length > 2) {
        window.alert('กรุณาเลือกตัวอย่างไม่เกิน 2 รายการ')
        return
      }
  
      const delivery = document.querySelector('.delivery.active')
      if (!delivery) {
        window.alert('กรุณาเลือกวิธีการจัดส่ง')
        return
      }
  
      // 選択サンプルの値をセット
      document.getElementById('sample_product1').value = choices[0].getAttribute('data-id')
      if (choices.length === 2) {
        document.getElementById('sample_product2').value = choices[1].getAttribute('data-id')
      }
  
      // 配送方法の値をセット
      document.getElementById('sample_delivery').value = delivery.getAttribute('data-id')
      
      // フォームを送信
      document.getElementById('the-form').submit()
    })

  }

}
